<template>
  <div class="more-recipes">
    <span>More recipes</span>
    <div class="buttons">
      <button @click="show = 'similar'" :class="{active: show == 'similar'}">Similar</button>
      <button @click="show = 'random'" :class="{active: show == 'random'}">Random</button>
    </div>
    <template v-if="show == 'similar'">
      <div
        @click="gotoRecipe(recipe.Url)"
        class="more-recipes-item"
        :class="{'done': recipe.Done}"
        v-for="(recipe,index) in similarRecipes"
        :key="index"
      >
        <fa v-if="recipe.Done" icon="check" />
        <div class="recipe-image" :style="{ backgroundImage: `url(${imageUrl(recipe)})` }"></div>
        <tags :list="unique(recipe.Categories)" />
        <p>{{ recipe.Title }}</p>
      </div>
    </template>
    <template v-if="show == 'random'">
      <div
        @click="gotoRecipe(recipe.Url)"
        class="more-recipes-item"
        :class="{'done': recipe.Done}"
        v-for="recipe in random"
        :key="recipe.Id"
      >
        <fa v-if="recipe.Done" icon="check" />
        <div class="recipe-image" :style="{ backgroundImage: `url(${imageUrl(recipe)})` }"></div>
        <tags :list="unique(recipe.Categories)" />
        <p>{{ recipe.Title }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import imageHelper from "@/helpers/imageHelper";
import recipeHelper from "@/helpers/recipeHelper";
import { functions } from "@/assets/script/functions";
import tags from "@/components/common/Tags";

export default {
  data() {
    return {
      show: "similar"
    };
  },
  methods: {
    imageUrl(url) {
      return imageHelper.imageUrl(url.ImageUrl);
    },
    unique(arr) {
      return functions.getUnique(arr, "Name");
    },
    gotoRecipe(url) {
      this.$router.push({
        to: "Recipe",
        path: "/opskrift/" + url
      });
    }
  },
  beforeMount() {
    this.$store.commit("setRecipeUrl", this.$route.params.url);
  },
  computed: {
    similarRecipes() {
      return this.$store.getters.getXSimilarRecipes(3);
    },
    random() {
      const allRecipes = this.$store.getters.allRecipes;
      return recipeHelper.orderRecipeBy(allRecipes, 'random').slice(0, 3);
    }
  },
  components: {
    tags
  }
};
</script>

<style lang="scss">
.more-recipes {
  row-gap: 20px;
  display: inline-block !important;
  box-shadow: none !important;
  width: 100%;

  .buttons {
    margin: 0;
    display: grid;
    width: 100%;
    grid-auto-flow: column;
    margin-bottom: 20px;
    grid-template-columns: repeat(2, 1fr);
    box-shadow: var(--cardshadow);
    button {
      font-family: "Poppins";
      font-weight: 500;
      background: white;
      padding: 6px 16px;
      border: none;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
      &:last-of-type {
        border-right: none;
      }
      &.active {
        background: var(--main);
        color: white;
      }
    }
    :first-child {
      border-radius: 3px 0 0 3px;
    }
    :last-child {
      border-radius: 0 3px 3px 0;
    }
  }
  span {
    display: grid;
    row-gap: 20px;
  }
  .more-recipes-item {
    background: white;
    box-shadow: var(--cardshadow);
    border-radius: 10px;
    position: relative;
    margin-bottom: 20px;
    cursor: pointer;
    &:last-of-type {
      margin-bottom: 0;
    }
    &:hover .tags {
      opacity: 1;
    }
    .recipe-image {
      height: 160px;
      border-radius: 10px 10px 0 0;
      background-position: center;
      background-size: cover;
    }
    p {
      padding: 20px 10px;
      text-align: center;
      font-size: 0.8rem;
      color: var(--main);
      margin: 0;
    }
    .tags {
      top: auto;
      left: auto;
      background: none;
      box-shadow: none;
      .tag {
        font-size: 0.5rem;
      }
    }
  }
}
</style>